export enum PrintOptions {
    PACKING_SLIP = 'Packing Slip',
    INVOICE = 'Invoice'
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/print-option.enum.ts